import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SessionService } from '../../core/session.service';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/rosie-ai-business-receptionist/id6757593086';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.rosie.mobile';

@Component({
  selector: 'rosie-app-download-banner',
  templateUrl: './app-download-banner.component.html',
  styleUrls: ['./app-download-banner.component.scss'],
  standalone: false,
})
export class AppDownloadBannerComponent {
  @Input() variant: 'horizontal' | 'sidebar' = 'horizontal';
  @Input() dismissible = false;
  @Output() dismissed = new EventEmitter<void>();

  readonly appStoreUrl = APP_STORE_URL;
  readonly playStoreUrl = PLAY_STORE_URL;

  constructor(private session: SessionService) {}

  get isDesktop(): boolean {
    return !this.session.isMobileVersion;
  }

  dismiss(): void {
    this.dismissed.emit();
  }
}
